import React from 'react';

import {
	store,
	setRootModuleData,
	getRootModulePath,
	FlexBox,
	FlexBoxBlock,
	styled,
	createModelForState,
	Button,
	Icon
} from 'ps-gui';
import { getPhrase } from '../data/phrases';
import { ReactComponent as UserIcon } from '../svg/user.svg';
import { ReactComponent as LogoIcon } from '../svg/logo.svg';
import { withGlobalContext } from '../data/globalcontext';
import { logout } from '../data/session';
import { pushState } from '../data/history';

const Wrapper = styled.div`
	background: rgba(235, 246, 252);
	${props => props.theme.pageContentPadding}

	z-index: 100;
`;

const MenuItem = styled.span`
	display: inline-block;
	font-size: 16px;
	margin-left: 40px;
	cursor: pointer;
	&:not(.passive):hover {
		text-decoration: underline;
	}
	&.passive {
		cursor: default;
	}
	font-weight: ${props => props.fontWeight || '400'};
`;

const MenuText = styled.span`
	vertical-align: middle;
`;

const MenuIcon = styled.span`
	display: inline-block;
	vertical-align: top;
	margin-right: 4px;

`;

const LanguageSelection = styled.span`
	position: relative;
	top: -1px;
	.icon {
		margin-right: 8px;
		&.language.active {
			&:not(:hover) {
				opacity: 0.4;
			}
		}
	}
`;

const Links = styled.span`
	display: inline-block;
	position: relative;
	top: 1px;
	margin-right: 40px;
	a {
		text-decoration: none;
		color: ${props => props.theme.textColor};
		font-weight: 500;
		margin-left: 16px;
		&:hover {
			text-decoration: underline;
		}
	}
`;

const Logo = styled.span`
	font-weight: 300;
	font-size: 24px;
	vertical-align: middle;
	line-height: 21px;
	margin-right: 40px;
	* {
		fill: ${props => props.theme.textColor};
	}
	svg {
		position: relative;
		top: 2px;
	}
`;

const Buttons = styled.div`
	margin: 0px;
	display: inline-block;
	margin-left: 40px;
	.ps-button {
		margin: 0px;

		&[data-name=login] {
			padding-left: 22px;
			text-transform: uppercase;
			.icon {
				margin-right: 8px;
			}
		}
	}
`;

class PageHeader extends React.PureComponent {
	constructor() {
		super();
		this.showUserProfile = this.showUserProfile.bind(this);
		this.logout = this.logout.bind(this);
	}

	logout() {
		logout();
	}

	showUserProfile() {
		// root module je MainPageModule, pokud se to nekdy zmeni, je treba to tady zohlednit.
		pushState('UserProfile');
		let model = createModelForState(store.getState().getIn(getRootModulePath()));
		model = model.setSelectedModuleId('UserProfile');
		setRootModuleData(model.getData());
	}

	render() {
		const globalContext = this.props.globalContext;
		const langId = globalContext.getLanguageId();
		return (
			<Wrapper>
				<FlexBox alignItems="center">
					<FlexBoxBlock>
						<Logo>
							{
								!window.logoHi ?
									<a href="https://www.intergram.cz/" target="_blank" rel="noreferrer"><LogoIcon /></a>
									:
									<img alt="logo" src="/logo_hi.png" width="140px"/>

							}

						</Logo>
					</FlexBoxBlock>
					<FlexBoxBlock flexGrow="1">
					</FlexBoxBlock>
					<FlexBoxBlock>
						<Links>
							<a href="/gui?sam=ip" target="_blank" rel="noreferrer">{getPhrase('isrcDatabase')}</a>
							<a href="https://www.intergram.cz/caste-dotazy#klientsky-portal" target="_blank" rel="noreferrer">FAQ</a>
						</Links>
						<LanguageSelection>
							{
								['CZ', 'EN'].map(key => {
									return (
										<Icon
											key={key}
											name={'flag_' + key}
											active={key !== langId}
											className="language"
											onMouseDown={async () => {
												if (key !== langId) {
													const gc = await globalContext.setLanguageId(key);
													gc.apply();
												}
											}}
										/>
									);
								})
							}
						</LanguageSelection>
						{/*<MenuItem><MenuText>{getPhrase('help')}</MenuText></MenuItem>*/}
						{
							globalContext.isLoggedIn() ?
								<>
									<MenuItem onMouseDown={this.showUserProfile} fontWeight="900" >
										<MenuIcon><UserIcon /></MenuIcon>
										<MenuText>{globalContext.getUserDisplayName()}</MenuText>
									</MenuItem>
									<MenuItem
										onMouseDown={this.logout}
									>
										<MenuText>{getPhrase('logout')}</MenuText>
									</MenuItem>
								</>
								:
								<Buttons>
									<Button
										text={getPhrase('loginNoun')}
										type="full"
										iconName="userWhite"
										name="login"
										onAction={this.props.onLoginFormRequested}
									/>
								</Buttons>

						}
					</FlexBoxBlock>
				</FlexBox>
			</Wrapper>
		);
	}
}

// onMouseDown={this.showUserProfile}
export default withGlobalContext(PageHeader);
